import axios, {AxiosResponse} from "axios";
import {
    CreateAdvancePaymentRequest,
    RecognizeAllTransactionsResponse
} from "../types/types";
import {UseToast} from "../hooks/useToast";

export class BankTransactionService {
    private readonly url: string;
    private readonly toastHelpers : Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'>
    private readonly f : any;

    constructor(f: any, toastHelpers  : Pick<UseToast, 'showDeletedToast' | 'showUpdatedToast' | 'showCreatedToast' | 'showToast'> ) {
        this.toastHelpers = toastHelpers;
        this.f = f;
        this.url = '/bank/transactions';
    }

    async createPayment(bankTransactionId: number, invoiceId: number,amount: number){
        return new Promise<boolean>((resolve, reject) => {
            axios.post<boolean>(`${this.url}/${bankTransactionId}/invoice/${invoiceId}/payment/${amount}`).then(response => {
                resolve(response.data)
                this.toastHelpers.showCreatedToast(this.f, this.f({id: 'thePayment'}),'o', true);
            }).catch(error => {
                // this.toastHelpers.showToast('warn', this.f({id: 'operationUnsuccessful'}), "")
                reject(error);
            })
        })
    }

    async createAdvancePayment(bankTransactionId: number,advancePayment: CreateAdvancePaymentRequest) {
        return new Promise<boolean>((resolve, reject) => {
            axios.post<boolean>(`${this.url}/${bankTransactionId}/advance-payment`, advancePayment).then(response => {
                if(response.data){
                    this.toastHelpers.showToast("success", this.f({id: 'operationSuccessful'}), ``, false);
                    resolve(response.data)
                }
            }).catch(err => {
                // this.toastHelpers.showToast("error", this.f({id: 'operationUnsuccessful'}), '', false);
                reject(err);
            });
        })
    }

    async recognizeAll() {
        return new Promise<RecognizeAllTransactionsResponse>((resolve, reject) => {
            axios.post<RecognizeAllTransactionsResponse>(`${this.url}/recognize-all`).then(response => {
                if(response.data){
                    this.toastHelpers.showToast("success", this.f({id: 'operationSuccessful'}), this.f({id: "recognizedTransactionsMessage"}, {recognized: response.data.recognizedCount, total: response.data.totalCount}), false);
                    resolve(response.data)
                }
            }).catch(err => {
                // this.toastHelpers.showToast("error", this.f({id: 'operationUnsuccessful'}), '', false);
                reject(err);
            });
        })
    }

    async discardTransaction(bankTransactionId: number, discardReason: string) {
        return new Promise<boolean>((resolve, reject) => {
            axios.post<boolean>(`${this.url}/${bankTransactionId}/discard/${discardReason}`).then(response => {
                if(response.data){
                    this.toastHelpers.showToast("success", this.f({id: 'operationSuccessful'}), "", false);
                    resolve(response.data)
                }
            }).catch(err => {
                // this.toastHelpers.showToast("error", this.f({id: 'operationUnsuccessful'}), '', false);
                reject(err);
            });
        })
    }
}
